import { render, staticRenderFns } from "./OrderSucessful-company.vue?vue&type=template&id=0290d0b2"
import script from "./OrderSucessful-company.vue?vue&type=script&lang=js"
export * from "./OrderSucessful-company.vue?vue&type=script&lang=js"
import style0 from "./OrderSucessful-company.vue?vue&type=style&index=0&id=0290d0b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports